<template>
    <transition
        v-bind="$attrs"
        :css="false"
        @enter="onEnter">
        <div :class="[
            'scale-transition',
            isInView ? 'in-view': ''
        ]">
            <slot></slot>
        </div>
    </transition>
</template>

<script lang="ts" setup>
import { inView } from 'motion';
import { computed, ref } from 'vue';

const motionOK = !window.matchMedia('(prefers-reduced-motion)').matches;

const props = defineProps({
    delay: Number,
    target: {
        type: String,
        required: true
    },
    duration: {
        type: Number,
        default: .3
    }
})

const isInView = ref(false);

const onEnter = (el: Element) => {
    if (!motionOK) return;
    const els = el.querySelectorAll(props.target);
    
    els.forEach((el, key) => {
        (el as HTMLElement).style.setProperty('--index', key.toString())
        el.classList.add('scale-transition-target')
    })

    window.addEventListener('load', () => {
        inView(el, () => {
            isInView.value = true;
        })
    }, { once: true })
}

const transitionDelay = computed(() => props.delay ? props.delay + 's' : '0s')

</script>

<style>

@media not (prefers-reduced-motion) {

    .scale-transition-target {
        transform: scale(.9);
        opacity: 0;
    }

    html.loaded {
        .scale-transition-target {
            transition-delay: calc(v-bind(transitionDelay) + var(--index) * 100ms);
            transition-property: opacity, transform;
            transition-duration: .6s;
            transition-timing-function: cubic-bezier(.215, .61, .355, 1);
        }

        .scale-transition.in-view {
            .scale-transition-target {
                opacity: 1;
                transform: none;
            }
        }
    }
}
</style>